import React from "react";
export default (function () {
  return React.createElement("div", {
    className: "recorder__hotspot"
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 650",
    className: "icon",
    style: {
      height: "1em",
      width: "1.69231em"
    }
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "translate(1 1)"
  }, React.createElement("path", {
    d: "M51.013,651C55.125,631.288 62.051,607.839 73.711,584.519C93.743,544.427 162.19,519.264 256.92,484.413C267.864,480.401 279.108,476.28 290.625,471.968L290.625,406.249C278.617,396.07 252.99,369.542 249.96,326.203C243.792,320.936 238.907,311.902 236.096,299.921C231.484,280.435 233.858,257.291 247.914,243.809C247.477,242.363 247.013,240.78 246.522,239.279C237.297,208.767 230.474,157.513 243.792,119.987C256.92,83 319.91,60 381.222,60C435.805,60 512.888,76.757 522.331,123.972C530.027,162.508 510.541,211.605 500.061,237.969C499.243,240.07 498.369,242.308 497.578,244.328C511.169,257.865 513.434,280.68 508.904,299.921C506.065,311.902 501.18,320.936 495.012,326.203C491.983,369.542 466.356,396.07 454.375,406.249L454.375,471.968C465.837,476.28 477.082,480.401 488.026,484.413C582.755,519.264 651.203,544.427 671.262,584.519C682.911,607.839 689.839,631.288 693.958,651",
    style: {
      fill: "none",
      stroke: "#00eed6",
      strokeWidth: "3px"
    }
  }), React.createElement("path", {
    d: "M1020,238C1020,229.169 1012.83,222 1004,222L716,222C707.169,222 700,229.169 700,238L700,426C700,434.831 707.169,442 716,442L1004,442C1012.83,442 1020,434.831 1020,426L1020,238Z",
    style: {
      fill: "none",
      stroke: "#00eed6",
      strokeWidth: "3px",
      strokeDasharray: "7,7"
    }
  }))), React.createElement("div", {
    className: "recorder__hotspot-info recorder__hotspot-info--1"
  }, "Optimal position facing", React.createElement("br", null), "the camera"), React.createElement("div", {
    className: "recorder__hotspot-info recorder__hotspot-info--2"
  }, "Suggested placement for graphic overlays", React.createElement("br", null), "(available after recording)"));
});